import axios from 'axios';
import Links from '../constants/Links';
import { store } from '../redux/store';

const apiClient = axios.create({
    baseURL: Links.ESERUYANIK_API,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor for API calls
apiClient.interceptors.request.use(
    async (config) => {
        const state = store.getState();
        const token = state.auth?.accessToken;
        
        if (token) {
            config.headers.Authorization = `JWT ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default apiClient;
